
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
  Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  applyOrderTypeFromUrl,
  applyQuickAssistTicketId,
} from '../../helper/notificationOrderType';

const NotificationModal = ({ open, onClose, notification }) => {
  if (!notification) return null;

  const { title, message, context, logo, image, landingurl } = notification;

  const navigateToLanding = () => {
    if (landingurl) {
      applyQuickAssistTicketId(notification);
      applyOrderTypeFromUrl(landingurl);
      window.location.assign(landingurl);
    }
    onClose();
  };

  const handleActionClick = (e) => {
    e?.stopPropagation?.();
    navigateToLanding();
  };

  const handlePaperClick = () => {
    if (landingurl) {
      navigateToLanding();
    }
  };

  const getContextColor = () => {
    switch (context) {
      case 'SoS':
        return '#d32f2f';
      case 'Promotion':
        return '#ff9800';
      case 'Broadcast':
      default:
        return '#2196f3';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ zIndex: 16000 }}
      PaperProps={{
        onClick: landingurl ? handlePaperClick : undefined,
        sx: {
          borderRadius: 2,
          borderTop: `4px solid ${getContextColor()}`,
          ...(landingurl
            ? { cursor: 'pointer' }
            : {}),
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center' }}>
        {logo && (
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{ width: 32, height: 32, mr: 2, borderRadius: 1 }}
          />
        )}
        <Typography variant="h6" component="span" sx={{ flex: 1 }}>
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {image && (
          <Box
            component="img"
            src={image}
            alt="Notification"
            sx={{
              width: '100%',
              height: 'auto',
              borderRadius: 1,
              mb: 2
            }}
          />
        )}
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
          {message}
        </Typography>
        {context &&
          String(context).toLowerCase() !== 'broadcast' && (
          <Box
            sx={{
              mt: 2,
              display: 'inline-block',
              px: 1.5,
              py: 0.5,
              bgcolor: getContextColor(),
              color: 'white',
              borderRadius: 1,
              fontSize: '0.75rem',
              fontWeight: 'medium'
            }}
          >
            {context}
          </Box>
        )}
        {landingurl && (
          <Button
            fullWidth
            variant="contained"
            onClick={handleActionClick}
            sx={{ mt: 3 }}
          >
            View Details
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default NotificationModal;